import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable } from '@angular/core';
import {
  FacilityDocument,
  UploadFacilityDocument
} from '@umss/shared/data-access';
import { Observable } from 'rxjs';

import { FacilityContextService } from './facility-context.service';

@Injectable({ providedIn: 'root' })
export class FacilityDocumentsService {
  private http = inject(HttpClient);
  private facilityContext = inject(FacilityContextService);

  private readonly baseUrl = computed(() => {
    return `/api/Facilities/${this.facilityContext.facilityId()}/documents`;
  });

  getAll(): Observable<FacilityDocument[]> {
    return this.http.get<FacilityDocument[]>(`${this.baseUrl()}`);
  }

  create(
    payload: UploadFacilityDocument,
    facilityId?: string
  ): Observable<FacilityDocument> {
    const url = facilityId
      ? `/api/Facilities/${facilityId}/documents`
      : this.baseUrl();
    return this.http.post<FacilityDocument>(url, payload);
  }

  get(documentId: string): Observable<FacilityDocument> {
    return this.http.get<FacilityDocument>(`${this.baseUrl()}/${documentId}`);
  }

  delete(documentId: string): Observable<FacilityDocument> {
    return this.http.delete<FacilityDocument>(
      `${this.baseUrl()}/${documentId}`
    );
  }

  verify(documentId: string): Observable<void> {
    return this.http.post<void>(`${this.baseUrl()}/${documentId}`, {});
  }

  download(documentId: string): Observable<void> {
    return this.http.get<void>(`${this.baseUrl()}/${documentId}`);
  }
}
